"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onSelectFilter = exports.Icon = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var uniqBy_1 = tslib_1.__importDefault(require("lodash/uniqBy"));
var Checkbox_1 = require("../../../Checkbox");
var utils_1 = require("../../../utils");
var Button_1 = tslib_1.__importDefault(require("../../../Button"));
var ConfigProvider_1 = require("../../../ConfigProvider");
var Radio_1 = require("../../../Radio");
var hooks_1 = require("../../../utils/hooks");
var icons_1 = require("../../../icons");
Object.defineProperty(exports, "Icon", { enumerable: true, get: function () { return icons_1.FilterIcon; } });
function onSelectFilter(rows, columnIds, filterValue) {
    return rows.filter(function (row) {
        var rowValue = row.values[columnIds[0]];
        return filterValue.indexOf(rowValue) > -1;
    });
}
exports.onSelectFilter = onSelectFilter;
// 当接受的 filterValue 使得此函数返回 true 的话，会重置 filter 的结果
onSelectFilter.autoRemove = function (val) { return val.length === 0; };
function toSelectFilterValue(v) {
    if (Array.isArray(v))
        return v;
    if (v == null)
        return [];
    return [v];
}
function toSingleValue(v) {
    if (v.length === 0)
        return null;
    return v[0];
}
function toMultiValue(v) {
    return v;
}
function SelectFilter(props) {
    var parentPrefix = props.prefix, onClose = props.onClose, column = props.column;
    var prefix = utils_1.concat(parentPrefix, 'select');
    var langData = ConfigProvider_1.useLangData('table');
    var filterOptions = column.meta.filter;
    var type = filterOptions.type, value = filterOptions.value, optionItems = filterOptions.optionItems;
    var _a = hooks_1.useValue({
        valueFromProps: value === undefined ? undefined : toSelectFilterValue(value),
        defaultValue: toSelectFilterValue(),
        onChange: react_1.useCallback(function (val) {
            var _a, _b;
            if (filterOptions.type === 'select') {
                (_a = filterOptions.onChange) === null || _a === void 0 ? void 0 : _a.call(filterOptions, toSingleValue(val));
                return;
            }
            (_b = filterOptions.onChange) === null || _b === void 0 ? void 0 : _b.call(filterOptions, toMultiValue(val));
        }, [filterOptions])
    }), innerValue = _a.value, setInnerValue = _a.setValue;
    var optionitemViews = react_1.default.useMemo(function () {
        if (optionItems)
            return optionItems;
        // 如果没有传过滤项，则把待过滤的数据去重后作为过滤项
        var dataItems = uniqBy_1.default(column.preFilteredRows, function (row) { return row.values[column.id]; })
            .map(function (row) { return row.values[column.id]; })
            .map(function (data) { return ({ value: data, text: data }); });
        return dataItems;
    }, [column, optionItems]);
    function handleOk() {
        onClose();
    }
    function handleReset() {
        onClose();
        var val = toSelectFilterValue();
        setInnerValue(val);
        if (value === undefined) {
            column.setFilter(val);
        }
    }
    function handleItemChange(val) {
        setInnerValue(val);
        if (value === undefined) {
            column.setFilter(val);
        }
    }
    if (type === 'select') {
        return (react_1.default.createElement("ul", { className: prefix },
            react_1.default.createElement(Radio_1.RadioGroup, { value: toSingleValue(innerValue), onChange: function (val) { return handleItemChange(toSelectFilterValue(val)); } },
                optionitemViews.map(function (item, i) {
                    var optionPrefix = utils_1.concat(prefix, 'option');
                    var checkedPrefix = innerValue.indexOf(item.value) > -1 && utils_1.concat(optionPrefix, 'checked');
                    return (react_1.default.createElement("li", { key: i, className: classnames_1.default(optionPrefix, checkedPrefix) },
                        react_1.default.createElement(Radio_1.Radio, { value: item.value, className: utils_1.concat(prefix, 'option', 'checkbox') }, item.text)));
                }),
                react_1.default.createElement("li", { className: utils_1.concat(prefix, 'footer') },
                    react_1.default.createElement(Button_1.default, { type: "link", onClick: handleOk }, langData.filter.okText),
                    react_1.default.createElement(Button_1.default, { type: "link", onClick: handleReset }, langData.filter.resetText)))));
    }
    return (react_1.default.createElement("ul", { className: prefix },
        react_1.default.createElement(Checkbox_1.CheckboxGroup, { value: toMultiValue(innerValue), onChange: function (val) { return handleItemChange(toSelectFilterValue(val)); } },
            optionitemViews.map(function (item, i) {
                var optionPrefix = utils_1.concat(prefix, 'option');
                var checkedPrefix = innerValue.indexOf(item.value) > -1 && utils_1.concat(optionPrefix, 'checked');
                return (react_1.default.createElement("li", { key: i, className: classnames_1.default(optionPrefix, checkedPrefix) },
                    react_1.default.createElement(Checkbox_1.Checkbox, { value: item.value, className: utils_1.concat(prefix, 'option', 'checkbox') }, item.text)));
            }),
            react_1.default.createElement("li", { className: utils_1.concat(prefix, 'footer') },
                react_1.default.createElement(Button_1.default, { type: "link", onClick: handleOk }, langData.filter.okText),
                react_1.default.createElement(Button_1.default, { type: "link", onClick: handleReset }, langData.filter.resetText)))));
}
exports.default = SelectFilter;
//# sourceMappingURL=index.js.map